"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faQuoteRight = void 0;
var faQuoteRight = {
  prefix: 'fas',
  iconName: 'faQuoteRight',
  icon: [448, 512, [], '', 'M96 96C42.98 96 0 138.1 0 192s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192C192 138.1 149 96 96 96zM448 192c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192z']
};
exports.faQuoteRight = faQuoteRight;